module.exports = __webpack_public_path__ + "static/media/database-remove.6cc621a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/database-remove.svg
// module id = 2715
// module chunks = 7